<template>
  <div>
    <el-container class="content">
      <el-aside v-show="isCollapse == false" class="aside" width="266px">
        <div class="box">
          <div class="img">
            <!-- <img :src="orgPhoto" alt="" /> -->
            <img
              src='/logo.png'
              alt=""
              style="width: 34px; height: auto"
            />
          </div>
          <div class="txt">兴康智慧服务管理平台</div>
        </div>
        <el-row class="tac">
          <el-col>
            <el-menu
              :default-active="$route.path"
              background-color="#fff"
              text-color="#ffffff"
              :unique-opened="true"
              :router="true"
            >
              <menu-item
                v-for="(item, index) in menuList"
                :key="index"
                :item="item"
              ></menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </el-aside>
      <el-container class="content-box">
        <el-header height="" v-if="isScreen">
          <div class="header">
            <div>
              <button>
                <i class="el-icon-s-fold" @click="Showaside"></i>
              </button>
              <span style="margin-left: 10px">{{ $store.state.title}}</span>
              <!--              <div class='orgs' v-if="$route.name == 'bigScreen'">-->
              <!--                <span>所属机构：</span>-->
              <!--                <el-cascader-->
              <!--                  ref='orgId'-->
              <!--                  :show-all-levels='false'-->
              <!--                  :options='quyuList'-->
              <!--                  v-model='orgIds'-->
              <!--                  :props="{-->
              <!--                                        checkStrictly: true,-->
              <!--                                        emitPath: false,-->
              <!--                                        label: 'label',-->
              <!--                                        value: 'orgId',-->
              <!--                                    }"-->
              <!--                  clearable-->
              <!--                >-->
              <!--                </el-cascader>-->
              <!--                <el-button-->
              <!--                  type='primary'-->
              <!--                  class='sure'-->
              <!--                  @click='changeOrg'-->
              <!--                >确定-->
              <!--                </el-button-->
              <!--                >-->
              <!--              </div>-->
            </div>

            <div>
              <div>
                <i class="el-icon-refresh" @click="$router.go(0)"></i>
                <p>{{ gettime }}</p>
              </div>
              <el-dropdown
                trigger="click"
                style="cursor: pointer"
                @command="tapMenu"
              >
                <span class="el-dropdown-link">
                  <i class="el-icon-user-solid"></i>
                  {{ $store.state.info.name }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="out">退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-header>
        <headLine v-if="$route.name != 'bigScreen'"></headLine>
        <el-main
          class="time_bank_container concatMain"
          :class="{
            active: $route.name == 'visualized' || $route.name == 'bigScreen',
          }"
        >
          <router-view v-if="isRouterAlive"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { Loginout } from "@/api/http.js"
import menuItem from "@/components/menuItem"
import headLine from "./components/headline"
import exportVue from "@/utils/exportVue"

export default {
  data() {
    return {
      isCollapse: false, // 按钮开关
      gettime: "", // 当前时间
      menuList: [], //菜单列表
      isRouterAlive: true,
      quyuList: [],
      dataIds: [],
      allList: [],
      orgIds: "",
      isScreen: true,
      orgPhoto: "",
    }
  },
  components: {
    menuItem,
    headLine,
  },
  provide() {
    //提供
    return {
      reload: this.reload,
    }
  },
  methods: {
    tapMenu(type) {
      if (type === "out") {
        this.goOut()
      }
    },
    goOut() {
      this.$store.state.title = "工作台"
      Loginout({ token: sessionStorage.getItem("tokens") })
      this.$router.push("/login")
    },
    Showaside() {
      this.$emit("change")
    },
    // 跳转
    gopage(pageName) {
      this.$router.push({ name: pageName })
    },
    // 隐藏侧边栏点击按钮事件
    Showaside() {
      this.isCollapse = !this.isCollapse
      this.isScreen = !this.isScreen
    },
    // --------------------------------------------------
    // 获取时间
    getTime() {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes()
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds()
      _this.gettime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss
    },
    currentTime() {
      setInterval(this.getTime, 500)
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    // 获取组织树
    getTree() {
      this.$post("/rbac/admin/org/info/OrgTreelist", { isValid: 1 }).then(
        (res) => {
          if (res.code === 200) {
            //当前账号绑定的机构所有下级
            this.allList = res.content
            let treeList = []
            this.quyuList = this.chbehavior(
              res.content,
              this.$store.state.info.orgId
            )
            let orgLevel = this.getorgLevel(
              res.content,
              this.$store.state.info.orgId
            )
            //当前机构等级不是总公司、省级、市级 就没有派发权限
            if (orgLevel == 0 || orgLevel == 1 || orgLevel == 2) {
              this.levelStatus = false
            } else {
              this.levelStatus = true
            }
            if (!this.quyuList.children) {
              //this.quyuList = [];//当前账号绑定的机构没有下级时就置空
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
              })
              this.quyuList = treeList //带同级本身的数据
            } else {
              //this.quyuList = this.quyuList.children;// 不带本身同级，只取下级
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
                children: this.quyuList.children,
              })
              this.quyuList = treeList //带同级本身的数据
            }
          }
        }
      )
    },
    //递归获取当前机构数据
    chbehavior(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },

    //获取当前机构等级
    getorgLevel(arr, id) {
      let res
      ;(function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a.orgLevel
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },

    //回显(多级)
    changeDetSelect(value, key, treeData) {
      let arr = [] // 在递归时操作的数组
      let returnArr = [] // 存放结果的数组
      let depth = 0 // 定义全局层级
      // 定义递归函数
      function childrenEach(childrenData, depthN) {
        for (var j = 0; j < childrenData.length; j++) {
          depth = depthN // 将执行的层级赋值 到 全局层级
          arr[depthN] = childrenData[j][key]
          if (childrenData[j][key] == value) {
            returnArr = arr.slice(0, depthN + 1) //将目前匹配的数组，截断并保存到结果数组，
            break
          } else {
            if (childrenData[j].children) {
              depth++
              childrenEach(childrenData[j].children, depth)
            }
          }
        }
        return returnArr
      }

      return childrenEach(treeData, depth)
    },
    changeOrg() {
      if (this.orgIds) {
        let disOrgId = this.changeDetSelect(this.orgIds, "orgId", this.quyuList)
        //当前选择的机构id和账号绑定机构id一样的时候不给派发权限
        let currentDisOrgId = disOrgId[disOrgId.length - 1] //当前派发机构id

        //获取当前选择的机构所有下级的id(不含本级)
        let treeList = []
        let currentOrgChildrenList = this.chbehavior(
          this.quyuList,
          currentDisOrgId
        ) //获取选择当前机构下级
        if (!currentOrgChildrenList.children) {
          treeList.push({
            label: currentOrgChildrenList.label,
            orgId: currentOrgChildrenList.orgId,
          })
          currentOrgChildrenList = treeList
        } else {
          treeList.push({
            label: currentOrgChildrenList.label,
            orgId: currentOrgChildrenList.orgId,
            children: currentOrgChildrenList.children,
          })
          currentOrgChildrenList = treeList //带同级本身的数据
        }
        //获取当前选择的机构所有下级id集合
        let childrenIdList = this.getChildrenId(currentOrgChildrenList)
        this.dataIds = childrenIdList
        exportVue.$emit("dataIds", this.dataIds)
      }
    },
    getChildrenId(arr) {
      let res = []
      ;(function deepId(arr) {
        for (let i = 0; i < arr.length; i++) {
          res.push(arr[i].orgId)
          if (arr[i].children) {
            deepId(arr[i].children)
          }
        }
      })(arr)
      return res
    },
  },
  created() {
    console.log(this.$route)
    this.currentTime()
    this.getTree()
    //判断是否点击全屏
    exportVue.$on("isSHow", (data) => {
      if (data == true) {
        this.Showaside()
      }
    })
    let menuData = this.$store.state.menu
    let [{ children = [] }] = menuData.filter(
      (item) => item.menuType == 1 && item.title == "居家服务"
    )
    let temp = children.filter(
      (item) => item.menuType == 2 && item.title == "客服中心"
    )
    this.menuList = temp[0].children
    this.orgPhoto = this.$store.state.info.orgPhoto
  },
}
</script>
<style lang="less" scoped>
@import "./assets/iconfont/iconfont.css";

html,
body {
  ::-webkit-scrollbar {
    width: 0 !important;
  }

  ::-webkit-scrollbar {
    width: 0 !important;
    height: 0;
  }
}

.orgs {
  display: inline-block !important;
  margin-left: 10px;

  .el-cascader {
    display: inline-block !important;
  }
}

/deep/ .table_checkbox {
  .el-checkbox-group {
    display: flex;
    flex-direction: column;
  }
}

/deep/ .time_bank_container {
  //padding: 20px 20px 42px 20px !important;

  &.active {
    padding: 0 !important;
  }

  .table_title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 24px;

    .screen_container {
      display: flex;
      margin-left: auto;
    }

    .btn_group {
      margin-top: 42px;
    }
  }

  /deep/ .dialog_container {
    .el-dialog__header {
      border-bottom: 1px solid #e5e5e5;
    }

    .el-dialog__body {
      padding-left: 60px;
      padding-right: 60px;
    }

    .dialog_content {
      .el-col {
        text-align: center;
      }

      .el-select {
        .el-input__inner {
          width: 100%;
        }
      }

      .table_add_wraoper {
        .add_table {
          margin-top: 24px;
        }
      }
    }

    .el-dialog__footer {
      background: #f5f5f5;
      padding: 8px 15px;
      border-top: 1px solid #e5e5e5;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }

  .table_container {
    margin-top: 12px;
  }

  .pagination_container {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
}

.content {
  height: 100vh;
  text-align: left;
  background: #f0f2f5;

  .aside {
    height: 100vh;
    background-color: #fff;
    transition: 0.3s;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;

    .box {
      margin: 10px 0;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      flex-direction: row;

      .img {
        margin-left: 20px;
        width: 43px;
        height: 100%;
        display: inline-block;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .txt {
        // 
        font-size: 18px;
        color: #000d37;
      }
    }

    /deep/ .tac {
      // display: flex;
      width: 100%;

      span {
        font-size: 13px;
        color: #ffffff;
      }

      .el-menu {
        border-right: unset;
      }

      .el-menu-item .el-submenu__title {
        width: 100%;
        height: 52px;
      }

      .el-submenu .el-menu-item {
        padding: 0;
        height: 52px;
        min-width: 100%;
      }

      .el-submenu__title {
        // padding-right: 10px;
        font-size: 13px;
      }
    }
  }

  .content-box {
    padding: 0 15px;
  }

  .el-header {
    display: flex;
    height: 70px;
    align-items: center;
    background: #ffffff;
    border-radius: 16px;

    .header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      div:nth-child(1) {
        button {
          width: 35px;
          height: 35px;
          border: none;
          border-radius: 4px;
          padding: 0px;

          /deep/ .el-icon-s-fold {
            font-size: 20px;
            color: #000000;
          }
        }

        button:hover {
          transition: 0.8s;
          background-color: #d4d4d4;
        }

        span {
          font-size: 20px;
          color: #333333;
        }

        .sure {
          margin-left: 15px;
          width: 70px;
        }

        .sure:hover {
          transition: 0s;
          background-color: #409eff;
        }
      }

      div:nth-child(2) {
        display: flex;
        justify-content: center;
        align-items: center;

        div:nth-child(1) {
          display: flex;
          margin-right: 40px;

          .el-icon-refresh {
            font-size: 25px;
            font-weight: bold;
            margin-right: 20px;
            cursor: pointer;
          }

          p {
            font-size: 20px;
            color: #333333;
            width: 200px;
          }
        }

        div:nth-child(2) {
          border-radius: 19px;
          background-color: #fcfeff;
          padding: 5px;

          span {
            display: flex;
            border-radius: 50%;
            align-items: center;
            justify-content: center;
            margin-right: 8px;

            .el-icon-user-solid {
              color: #fff;
              background: #bbb;
              border-radius: 50%;
              padding: 5px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }

  .el-main {
    padding: 0;
    background-color: rgba(242, 242, 242, 1);
  }

  .el-icon-s-fold {
    color: #ffffff;
  }

  .el-icon-caret-right {
    color: #ffffff;
  }

  /deep/ .el-icon-arrow-down:before {
    //  color: #fff;
    //font-size: 18px;
    content: "\E6DF";
    font-weight: bold;
  }

  /deep/ .el-submenu__title /deep/ .el-menu-item {
    padding-left: 10px !important;
  }
}
</style>
